<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="移动方式" name="1">
        <div class="lineHeight32">
          <span style="margin-right: 15px">移动速度</span>
          <el-select v-model="speeds" style="width: 156px">
            <el-option
              v-for="(option, index) in moveSpeedList"
              :key="index"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Object }
  },
  data() {
    return {
      activeNames: ["1"],
      moveSpeedList: [
        {
          value: 200,
          label: "快速"
        },
        {
          value: 100,
          label: "中速"
        },
        {
          value: 50,
          label: "慢速"
        }
      ]
    }
  },
  computed: {
    speeds: {
      get() {
        return this.options.speeds
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "speeds", false)
      }
    }
  }
}
</script>
